import BulkEditContainer from "./BulkEditContainer";

export default BulkEditContainer;
